import { Component, OnInit } from "@angular/core";
import { RacesService } from "../raceServices/races.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "single-race",
  templateUrl: "singleRace.html",
  styles: ["./start.component.css"]
})
export class VilniusInfoComponent implements OnInit {
  currentDetails: any;
  arrayOfKeys: any = [];
  id: string;

  constructor(
    private racesService: RacesService,
    private activated: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activated.params.subscribe(result => (this.id = result["id"]));
    this.racesService
      .getCircuitDetails(this.id)
      .valueChanges()
      .subscribe(circuitDetails => {
        this.currentDetails = circuitDetails;
        this.arrayOfKeys = Object.keys(this.currentDetails).filter(key => key !== 'title');
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/races/r1/raceSingle.component.ts